import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  buttonCreate: {
    width: 150,
    height: 50,
    textTransform: 'none',
    fontWeight: 'bold',
  },
  arrowMargin: {
    marginTop: 50,
  },
  headerTitle: {
    maxWidth: 450,
    margin: 'auto',
    textAlign: 'center',
    marginBottom: 35,
    fontWeight: 'bold',
  },
  imageCenter: {
    textAlign: 'center',
  },
  menuBar: {
    width: 350,
  },
  infoBackground: {
    background: '#F5F5F5',
    marginTop: 30,
    marginBottom: 40,
  },
  btnTextTransfrom: {
    textTransform: 'none',
  },
}))

export default useStyles
